<template>
  <div class="user-avatar">
    <div class="avatar-container" style="margin-bottom:20px;" v-if="avatar">
      <Avatar :src="avatar" size="200"/>
      <Spin size="small" fix v-if="isSaving"></Spin>
    </div>
    <UploadFile class="avatar-upload" @upload="handleUploadAvatar">
      <div slot="content">
        <Button class="k-btn-2" v-if="avatar">Change photo</Button>
        <div class="drag-photo" v-if="!avatar">
          <Icon type="md-image" size="50"/>
          <p>Drag your photo here, </p>
          <Button class="k-btn-2">Browse</Button>
        </div>
      </div>
    </UploadFile>
  </div>
</template>

<script>
import { updateAccount } from '@/services/account'
import UploadFile from '@/components/ui/UploadFile'

export default {
  components: {
    UploadFile
  },

  props: {
    avatar: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isSaving: false
    }
  },

  methods: {
    handleUploadAvatar (file) {
      this.isSaving = true
      const userId = localStorage.getItem('_id')

      const data = {
        avatar: file
      }

      updateAccount(userId, data).then(res => {
        this.$router.go(this.$router.currentRoute)
        this.isSaving = false
      }).catch(err => {
        console.log('Failed to upload user avatar: ', err)
        this.isSaving = false
      })
    }
  }
}
</script>

<style lang="scss">
  .user-avatar {
    .avatar-upload {
      .ivu-upload-select {
        .drag-photo {
          width: 100%;
          padding: 30px;
          border: 2px dashed $secondaryLighter;
          p {
            margin-top: 15px;
          }
          button {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>
